<template>
  <div class="nav_main" :class="{ active: show }">
    <div class="DetailedNavigation" @click.stop="">
      <div class="nav_box font-sySong">
        <div class="nav_home" :class="{ active: mainSelected == -1 && subSelected == -1 }"><span @click="handleBackClick">首页</span></div>
        <div class="nav_content">
          <div class="nav_item" v-for="(el, elI) in navList" :key="elI">
            <div class="item_title" :class="{ active: mainSelected == elI }">
              <span @click="handleItemClick($event, elI)">{{ el.label }}</span>
            </div>
            <div class="sub_box">
              <div class="sub_item" v-for="(subEl, subElI) in el.children" :key="subElI">
                <div class="sub_title" :ref="`D${elI}${subElI}`" @click="handleItemClick($event, elI, subElI)" :class="{ active: mainSelected == elI && subSelected == subElI }">
                  <div class="icon_box">
                    <i class="icon" v-if="!subEl.notTitle && !subEl.newSubNav" :class="`el-icon-arrow-${subEl.subNav.length > 0 ? 'down' : 'right'}`"></i>
                  </div>
                  <p>{{ subEl.label }}</p>
                </div>
                <div class="sub_inner" v-if="subEl.newSubNav">
                  <p v-for="(ancEl, ancElI) in subEl.newSubNav" :key="ancElI" :class="{ active: mainSelected == elI && subSelected == subElI && ancElI == lastSelected }">
                    <span @click="BackancItemIndex2(ancEl, ancElI, elI, subElI)">·{{ ancEl.label }}</span>
                  </p>
                </div>
                <div class="sub_inner" v-if="subEl.subNav && subEl.subNav.length > 0 && !subEl.newSubNav">
                  <p :class="{ active: ancElI === lastSelected }" v-for="(ancEl, ancElI) in subEl.subNav" :key="ancElI">
                    <span @click="BackancItemIndex(ancEl, ancElI, elI, subElI)">·{{ ancEl.label }}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="nav_item"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DetailedNavigation',
  data() {
    return {
      navList: [
        {
          label: '八代九王',
          children: [
            { label: '楚王世系', section: '第一章', path: '/ChuKingPedigree', subNav: [] },
            { label: '楚王生平', section: '第二章', path: '/ChuKingTimeLine', subNav: [] },
            { label: '谥号解读', section: '第三章', path: '/ShiHaoJiedu', subNav: [] }
          ]
        },
        {
          label: '楚藩回首',
          children: [
            { label: '明藩沉浮', section: '第一章', path: '/MingFanChengFu', subNav: [], newSubNav: [{ label: '楚国渊源', path: '/ChuGuoYuanYuan' }] },
            // { label: '楚国渊源', section: '第一章', path: '/ChuGuoYuanYuan', subNav: [] },
            { label: '明楚简史', section: '第二章', path: '/ChuKingBrief', notTitle: true },
            { label: '楚藩轶事', section: '第三章', path: '/ChuFanYiShi', subNav: [], newSubNav: [{ label: '土地官司', path: '/TuDiGuansi' }] }
            // { label: '土地官司', section: '第四章', path: '/TuDiGuansi', subNav: [] }
          ]
        },
        {
          label: '楚王墓群',
          children: [
            { label: '选址布局', section: '第一章', path: '/XuanZhiBuJu', subNav: [] },
            { label: '九座墓园', section: '第二章', path: '/JiuZuoMuyuan', subNav: [] },
            { label: '出土文物', section: '第三章', path: '/ChuTuWenWu', subNav: [] }
          ]
        },
        {
          label: '龙泉福地',
          children: [
            { label: '龙泉四季', section: '第一章', path: '/LongQuanSiJi', subNav: [] }, //
            { label: '历史景观', section: '第二章', path: '/DaMeiJingGuan', notTitle: true }, //
            { label: '古代名人', section: '第三章', path: '/GuDaiMingRen', notTitle: true }
          ]
        }
      ],
      mainSelected: -1,
      subSelected: -1,
      lastSelected: -1,
      show: false
    }
  },
  mounted() {
    this.$EventBus.$on('showNav', has => (this.show = has))
    this.$EventBus.$on('injectNav', this.injectNav)
    this.mainSelected = localStorage.getItem('i1') === undefined ? -1 : localStorage.getItem('i1')
    this.subSelected = localStorage.getItem('i2') === undefined ? -1 : localStorage.getItem('i2')
    this.lastSelected = localStorage.getItem('i3') === undefined ? -1 : localStorage.getItem('i3')
    // this.navItem(params)
  },
  beforeDestroy() {
    this.$EventBus.$off('showNav', 'injectNav')
  },
  methods: {
    /**
     * injectNav函数用于向navList中的特定项注入subNav。
     * @param {Object} params - 包含label、subLabel和subNav的参数对象。
     * @param {string} params.label - 要注入subNav的父级label。
     * @param {string} params.subLabel - 要注入subNav的子级label。
     * @param {Array} params.subNav - 要注入的subNav数组。
     */
    injectNav(params) {
      this.lastSelected = 0
      let { label, subLabel, subNav } = params
      this.navList.forEach((el, elI) => {
        el.children.forEach((el2, el2I) => {
          el2.subNav = []
          if (el.label === label && el2.label === subLabel) {
            el2.subNav = subNav
            setTimeout(() => {
              this.$refs[`D${elI}${el2I}`][0].scrollIntoView()
            }, 0)
          }
        })
      })
    },
    handleItemClick(e, i1, i2 = 0) {
      //  点击一级标题清空二级标题索引
      this.lastSelected = null
      if (!this.navList[i1].children[i2].path) return

      this.mainSelected = i1
      this.subSelected = i2

      localStorage.setItem('i1', i1)
      localStorage.setItem('i2', i2)
      localStorage.setItem('i3', -1)

      const { path, label, section } = this.navList[i1].children[i2]
      const params = { label, section }
      params
      // this.$router.push({ path })
      this.$linkWx({ url: `/pages${path}` })
      this.show = false
      e
    },
    // 子页面跳转
    BackancItemIndex2(item, index, mainI, subI) {
      this.mainSelected = mainI
      this.subSelected = subI
      this.lastSelected = index

      localStorage.setItem('i1', mainI)
      localStorage.setItem('i2', subI)
      localStorage.setItem('i3', index)
      this.show = false

      this.$linkWx({ url: `/pages${item.path}` })
    },
    // 返回选中锚点索引
    BackancItemIndex(item, index, mainI, subI) {
      this.mainSelected = mainI
      this.subSelected = subI
      this.lastSelected = index

      localStorage.setItem('i1', mainI)
      localStorage.setItem('i2', subI)
      localStorage.setItem('i3', index)
      this.$EventBus.$emit('backIndex', index)
      this.show = false
    },
    handleBackClick() {
      this.show = false
      this.mainSelected = -1
      this.subSelected = -1
      // this.$router.push({ path: '/Dashboard' })
      this.$linkWx({ url: '/pages/Home' })
      localStorage.setItem('i1', -1)
      localStorage.setItem('i2', -1)
      localStorage.setItem('i3', -1)
      this.navList.forEach(el => {
        el.children.forEach(el2 => {
          el2.subNav = []
        })
      })
      // const params = { type: -1, label: null, section: null }
      // this.$EventBus.$emit('onMenuClick', params)
    }
  }
}
</script>

<style lang='scss' scoped>
.nav_main {
  width: 100%;
  height: 100%;
  background-color: transparent;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 9999;
  transition: all 0.5s;
  transform: translateX(100%);
}
.DetailedNavigation {
  position: absolute;
  width: 78%;
  height: 100%;
  top: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.8);

  font-size: 0.56rem;
  line-height: 1;
  color: #b0b0b0;
  .nav_box {
    height: 100%;
    overflow: auto;
    padding-left: 0.8rem;
    padding-top: 1.5rem;
    font-size: 0.56rem;
    .nav_home.active {
      color: #fff;
    }
    .nav_content {
      .nav_item {
        margin-top: 1.88rem;
        margin-bottom: 1.1rem;
        display: flex;
        .item_title {
          width: 2.96rem;
        }
        .item_title.active,
        .sub_title.active {
          color: #fff;
        }
        .sub_box {
          flex: 1;
          font-size: 0.44rem;
          line-height: 0.56rem;
          .sub_item {
            padding-left: 0.7rem;
            .icon {
              font-size: 0.44rem;
            }
            .sub_title {
              position: relative;
              left: -0.8rem;
              display: flex;
              align-items: center;
              gap: 0.4rem;
              position: relative;
              height: 0.56rem;
              line-height: 0.56rem;
              margin-bottom: 0.2rem;
              .icon_box {
                width: 0.43rem;
              }
            }
            .sub_inner {
              font-family: '楷体', 'KaiTi', '楷体_GB2312', serif;
              line-height: 1;
              font-size: 0.38rem;
              margin-bottom: 0.15rem;
              p {
                padding: 0.25rem 0;
                border-top: 1px solid #78633f;
                span {
                  position: relative;
                  left: -0.1rem;
                }
              }
              p.active {
                color: #c09042;
              }
            }
          }
        }
      }
    }
  }
}

.nav_main.active {
  transform: translateX(0);
}
</style>